module.exports = __webpack_public_path__ + "img/c-class-estate.37d909e7.jpg";